module.exports = __webpack_public_path__ + "static/turtle-creek-house35-d2e472751fb8c8bb8ec9958e4fe81a2f.jpg";